import { 
  User, Calendar, Pill, Activity, Scissors, Syringe, 
  AlertTriangle, TestTube, HelpCircle, History 
} from 'lucide-react';
import TabGrid from '@/components/ui/TabGrid';

/**
 * Medical Tab Configuration
 * Calming pastels for medical content
 */
const TAB_CONFIG = [
  {
    id: 'profile',
    label: 'Profile',
    icon: User,
    colors: {
      bg: '#E8EEF4',
      active: '#D0DCE8',
      text: '#4A5568',
      iconBg: '#D8E4EE',
    }
  },
  {
    id: 'appointments',
    label: 'Calendar',
    icon: Calendar,
    colors: {
      bg: '#EDE9F6',
      active: '#DCD4EE',
      text: '#5B4B8A',
      iconBg: '#E2DBEF',
    }
  },
  {
    id: 'medications',
    label: 'Medications',
    icon: Pill,
    colors: {
      bg: '#E0F4E8',
      active: '#C6E9D4',
      text: '#2D6A4F',
      iconBg: '#D2EFE0',
    }
  },
  {
    id: 'symptoms',
    label: 'Symptoms',
    icon: Activity,
    colors: {
      bg: '#FEE8DC',
      active: '#FDDACA',
      text: '#9C4221',
      iconBg: '#FDE0D0',
    }
  },
  {
    id: 'surgeries',
    label: 'Surgeries',
    icon: Scissors,
    colors: {
      bg: '#FCE4E4',
      active: '#F9D0D0',
      text: '#9B2C2C',
      iconBg: '#FAD8D8',
    }
  },
  {
    id: 'vaccinations',
    label: 'Vaccinations',
    icon: Syringe,
    colors: {
      bg: '#DBEAFE',
      active: '#BFDBFE',
      text: '#1E40AF',
      iconBg: '#CEE5FD',
    }
  },
  {
    id: 'allergies',
    label: 'Allergies',
    icon: AlertTriangle,
    colors: {
      bg: '#FEF9C3',
      active: '#FEF08A',
      text: '#854D0E',
      iconBg: '#FEF4A8',
    }
  },
  {
    id: 'labs',
    label: 'Labs/Tests',
    icon: TestTube,
    colors: {
      bg: '#D5F5F6',
      active: '#B2EBEC',
      text: '#0F766E',
      iconBg: '#C4F0F1',
    }
  },
  {
    id: 'questions',
    label: 'Questions',
    icon: HelpCircle,
    colors: {
      bg: '#EDE4F3',
      active: '#DDD0EA',
      text: '#6B21A8',
      iconBg: '#E4D8ED',
    }
  },
  {
    id: 'history',
    label: 'History',
    icon: History,
    colors: {
      bg: '#E2EDE6',
      active: '#C8DED0',
      text: '#22543D',
      iconBg: '#D5E5DB',
    }
  }
];

/**
 * MedicalTabs - Grid-based tab navigation for Medical module
 * All tabs visible at once - no scrolling, no hidden features
 */
const MedicalTabs = ({ activeTab, onTabChange, children }) => {
  return (
    <TabGrid
      tabs={TAB_CONFIG}
      activeTab={activeTab}
      onTabChange={onTabChange}
      testIdPrefix="tab"
    >
      {children}
    </TabGrid>
  );
};

export { TAB_CONFIG };
export default MedicalTabs;
